import http from "plugins/axios";

export default {
  getOrderList({ page, size, pair, startTime, endTime, userId }) {
    return http.get({
      url: `/la/admin/finance/order/list?page=${page}&size=${size}&pair=${pair}&startTime=${startTime}&endTime=${endTime}&userId=${userId}`,
    });
  },
  exportExcel({  pair, startTime, endTime, userId }){
    return http.get({
        url: `/la/admin/finance/order/list/excel?pair=${pair}&startTime=${startTime}&endTime=${endTime}&userId=${userId}`,
        responseType:'blob',
    })
  },
  getFbsPairs(){
    return http.get({
      url:'admin/symbol/fbsNames' //更改后的路径
      // url:' /la/admin/pair/list'
    })
   },
};
